import { Component } from '@angular/core';

@Component({
  selector: 'itl-desktop-list-item-additional-info',
  template: '<ng-content></ng-content>',
  standalone: false,
})
export class DesktopListItemAdditionalInfoComponent {}
